import React from "react";
import { Paper } from "@mui/material";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

export const AuthPageWrapper = ({
  image,
  imageElement,
  children,
  navLinkBack,
  navLinkBackLabel = "Back",
  navLinkNext,
  navLinkNextLabel = "Next",
  className = "",
  panelWidthStyle = "500px",
}: {
  image?: string;
  imageElement?: React.ReactNode;
  children: any;
  navLinkBack?: () => void;
  navLinkBackLabel?: string;
  navLinkNext?: () => void;
  navLinkNextLabel?: string;
  className?: string;
  panelWidthStyle?: string;
}) => {
  return (
    <div
      className="page page--contained"
      style={{
        backgroundImage: `url('/assets/images/globe.png'), linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%), radial-gradient(51.39% 64.02% at 38.92% 0%, #46A2D2 0%, rgba(70, 162, 210, 0.00) 100%), radial-gradient(84.99% 74.82% at 98.73% 19.6%, #5E32E5 0%, rgba(94, 50, 229, 0.00) 100%)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom left",
        backgroundSize: "auto",
      }}
    >
      <Paper className={`page-box p-relative ${className}`} sx={{ width: panelWidthStyle }}>
        {navLinkBack && (
          <div className="p-absolute abs-t-md abs-l-md page-box__header-nav page-box__header-nav-left">
            <a onClick={navLinkBack}>
              <ArrowBack /> {navLinkBackLabel}
            </a>
          </div>
        )}
        {navLinkNext && (
          <div className="p-absolute abs-t-md abs-r-md page-box__header-nav page-box__header-nav-right">
            <a onClick={navLinkBack}>
              <ArrowForward /> {navLinkNextLabel}
            </a>
          </div>
        )}
        <div className="page-box--inner">
          {image && (
            <div className="page-box__img-wrapper">
              <img src={image} className="page-box__img" />
            </div>
          )}
          {imageElement}

          <div className="page-box__content">{children}</div>
        </div>
      </Paper>
    </div>
  );
};
